import { render, staticRenderFns } from "./MobilePaymentTerms.vue?vue&type=template&id=2b1722f2&scoped=true"
import script from "./MobilePaymentTerms.vue?vue&type=script&lang=js"
export * from "./MobilePaymentTerms.vue?vue&type=script&lang=js"
import style0 from "./MobilePaymentTerms.vue?vue&type=style&index=0&id=2b1722f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1722f2",
  null
  
)

export default component.exports